export default __webpack_public_path__ + "static/media/Ilanit Eliaz.efa4199e.png";